'use client';

import { useEffect } from 'react';

import { ContextStoreProduct, storeProduct } from './store';

interface ClientStoreProductProps {
  state: ContextStoreProduct;
}

export function ClientStoreProduct({ state }: ClientStoreProductProps) {
  useEffect(() => {
    storeProduct.send({
      type: 'set',
      state
    });
  }, [state]);

  return null;
}
